import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPromptModal.css';

const LoginPromptModal = ({ isOpen, onClose, action = 'continue' }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleLogin = () => {
    onClose();
    navigate('/login', { state: { returnTo: '/forum' } });
  };

  const handleSignup = () => {
    onClose();
    navigate('/signup', { state: { returnTo: '/forum' } });
  };

  const getActionMessage = () => {
    const messages = {
      reply: 'Reply to this post',
      vote: 'Vote on this content',
      create: 'Ask a question',
      continue: 'Continue'
    };
    return messages[action] || messages.continue;
  };

  return (
    <div className="login-prompt-overlay" onClick={onClose}>
      <div className="login-prompt-modal" onClick={(e) => e.stopPropagation()}>
        <div className="login-prompt-header">
          <div className="login-prompt-icon">
            <i className="bi bi-person-circle"></i>
          </div>
          <h2>Join the Conversation</h2>
          <button className="login-prompt-close" onClick={onClose} aria-label="Close">
            <i className="bi bi-x"></i>
          </button>
        </div>

        <div className="login-prompt-body">
          <p className="login-prompt-message">
            You need to be logged in to <strong>{getActionMessage()}</strong>.
          </p>
          <p className="login-prompt-submessage">
            Join our community to participate in discussions, share your knowledge, and connect with other members.
          </p>

          <div className="login-prompt-features">
            <div className="feature-item">
              <i className="bi bi-check-circle-fill"></i>
              <span>Post questions and get answers</span>
            </div>
            <div className="feature-item">
              <i className="bi bi-check-circle-fill"></i>
              <span>Engage with the community</span>
            </div>
            <div className="feature-item">
              <i className="bi bi-check-circle-fill"></i>
              <span>Build your professional profile</span>
            </div>
          </div>
        </div>

        <div className="login-prompt-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Continue Browsing
          </button>
          <div className="login-prompt-actions">
            <button className="btn btn-outline-primary" onClick={handleSignup}>
              <i className="bi bi-person-plus"></i>
              Sign Up
            </button>
            <button className="btn btn-primary" onClick={handleLogin}>
              <i className="bi bi-box-arrow-in-right"></i>
              Log In
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPromptModal;

